export default __webpack_public_path__ + "static/collection-3-6f37a10bc7645d2d6b7ea6267f650041.webp";